export default {
  // Canvas type
  multiCurrencyCanvas: "Multi-Currency Canvas",

  // Canvas name
  unnamedCanvas: "Unnamed Canvas",

  // Case name
  caseName: "Case: ",

  // Search box
  searchPlaceholder: "Search address / hash / survey user ID",

  // Buttons
  startAnalysis: "Start Analysis",
  switchToOldVersion: "Switch to Old Version",
  expandConfig: "Extended Config",
  refresh: "Refresh",
  shareCanvas: "Share Canvas",
  save: "Save",

  // Tooltips
  expandOrCollapseConfig: "Expand or collapse extended configuration items",

  // Dropdown menu
  surveyDataUpdate: "Survey Data Update",
  labelUpdate: "Label Update",
  noteUpdate: "Note Update",
  addressBalanceUpdate: "Address Balance Update",
  lastUpdate: "Last update: ",

  // Dialog
  dialogTitle: "Prompt",
  balanceUpdateMessage:
    "Current canvas has {count} addresses, updating balance will take a long time, please be patient!",
  cancel: "Cancel",
  confirm: "Confirm",

  // Currency options
  allCurrencies: "All",
};
